// will add a custom media query here so that the styles are applied only when the height of the screen is between 300px and 450px.
// Since MUI's breakpoint system does not directly support height conditions

// Used this to support lanscape mode on mobile for discover mode
export const MEDIA_SCREEN_HEIGHT_300_450 = '@media (min-height: 300px) and (max-height: 450px)';
